import assetIcCheckmarkColor from './ic-checkmark-color.svg';
import assetIcCheckmarkSmall from './ic-checkmark-small.svg';
import assetIcDelete from './ic-delete.svg';
import assetIcShirt from './ic-shirt.svg';
import assetIcSortAlt from './ic-sort-alt.svg';
import assetIcSort from './ic-sort.svg';
export enum FilterFlyoutIconName {
  ColorCheckmark = 'ColorCheckmark',
  ColorCheckmarkSmall = 'ColorCheckmarkSmall',
  Delete = 'Delete',
  Shirt = 'Shirt',
  Sort = 'Sort',
  SortAlt = 'SortAlt',
}

export const filterFlyoutIconAssets: {
  [key in FilterFlyoutIconName]: string;
} = {
  [FilterFlyoutIconName.ColorCheckmark]: assetIcCheckmarkColor,
  [FilterFlyoutIconName.ColorCheckmarkSmall]: assetIcCheckmarkSmall,
  [FilterFlyoutIconName.Delete]: assetIcDelete,
  [FilterFlyoutIconName.Shirt]: assetIcShirt,
  [FilterFlyoutIconName.Sort]: assetIcSort,
  [FilterFlyoutIconName.SortAlt]: assetIcSortAlt,
};
